import { SummarySubTitle as Container } from './styles'

export function SummarySubTitle({ children }) {
  return <Container>{children}</Container>
}
